import { Company } from '@common/types/company.types'
import { IntlShape } from 'react-intl'

/**
 * Company name followed by its country
 * @param company
 * @param formatMessage
 */
export const getCompanyNameAndCountry = (company: Company, formatMessage: IntlShape['formatMessage']): string => (
	`${company.name} - ${formatMessage({ id: `global.enums.companyCountry.${company.countryCode}` })}`
)

/**
 * Parent company between parentheses, only shown to admins.
 * Needed to tell apart companies sharing a name and a country under different trainer companies.
 * @param company
 * @param formatMessage
 * @param isAdmin
 */
export const getCompanyParentLabel = (company: Company, formatMessage: IntlShape['formatMessage'], isAdmin: boolean): string | undefined => (
	isAdmin && company.parent
		? ` (${getCompanyNameAndCountry(company.parent, formatMessage)})`
		: undefined
)

/**
 * Whole company label, as a single string
 * @param company
 * @param formatMessage
 * @param isAdmin
 */
export const getCompanyLabel = (company: Company, formatMessage: IntlShape['formatMessage'], isAdmin: boolean): string => (
	`${getCompanyNameAndCountry(company, formatMessage)}${getCompanyParentLabel(company, formatMessage, isAdmin) ?? ''}`
)
